export const extractItemIdFromSlug = (slug: string) => {
  const match = slug.match(/(\d+)/)

  return match ? parseInt(match[1]!, 10) : null
}
